<div class="cw-module">
  <div class="cw-flex-row">
    <!-- Überschrift -->
    <h2 [ngClass]="{'cw-icon-container': headerIcon.length > 0}">
      <span class="cw-grid-icon {{ headerIcon }}"></span> {{ headerText }}
    </h2>

    <!-- Zusätzliche Icons -->
    @if (institutionIcons && institutionIcons.length) {
      <phscw-entity-icons
        [entityId]="institutionId"
      [iconString]="institutionIcons"></phscw-entity-icons>
    }

    <!-- Toolbar -->
    <phscw-toolbar
      componentIdentifier="institutionsDetails"
      [componentConnection]="$any(this)"
      [buttonAdd]="enableAddPersonButton && allowNewPerson && institutionId > 0"
      buttonAddTooltip="{{ 'MODULES.PEOPLE.DETAILS.ADDNEW' | translate }}"
      [buttonAddParameter]="institutionId"
      [buttonFullscreen]="true"
      [fullscreenSize]="75"
            [buttonAddChild]="
                enableAddDepartmentButton &&
                permissionAllowMoveInstitution &&
                institutionId > 0 &&
                maxHierarchyLevel > currentHierarchyLevel &&
                allowNewDepartment
            "
      [buttonAddChildParameter]="{disabled: !allowMoveInstitution}"
      buttonAddChildTooltip="{{ 'MODULES.INSTITUTIONS.LIST.ADDNEWDEPARTMENT' | translate }}">
    </phscw-toolbar>
  </div>

  <!-- Submodule -->
  <div class="cw-institutiondetails">
    @for (activeSubmodule of activeSubmodules; track activeSubmodule) {
      <!-- Kampagnen -->
      @if (activeSubmodule === 'campaigns') {
        <phscw-campaigns parentModule="institutions"></phscw-campaigns>
      }
      @if (activeSubmodule == 'data') {
        <phscw-institutions-data></phscw-institutions-data>
      }
      <!-- Opportunities -->
      @if (activeSubmodule === 'opportunities' && permissionEnableModuleOpportunities) {
        <phscw-institutions-opportunities></phscw-institutions-opportunities>
      }
      @if (activeSubmodule == 'people') {
        <phscw-institutions-people></phscw-institutions-people>
      }
      @if (activeSubmodule == 'characteristics') {
        <phscw-institutions-characteristics
        ></phscw-institutions-characteristics>
      }
      @if (activeSubmodule == 'contacts') {
        <phscw-institutions-contacts></phscw-institutions-contacts>
      }
      @if (activeSubmodule == 'notes') {
        <phscw-institutions-notes></phscw-institutions-notes>
      }
      @if (activeSubmodule == 'public-note') {
        <phscw-institutions-public-note></phscw-institutions-public-note>
      }
      @if (activeSubmodule == 'openinghours') {
        <phscw-institutions-openinghours
        ></phscw-institutions-openinghours>
      }
      @if (activeSubmodule == 'clienttemplates') {
        <phscw-institutions-clienttemplates
        ></phscw-institutions-clienttemplates>
      }
      @if (activeSubmodule == 'affiliation') {
        <phscw-entity-affiliation
          [activeID]="institutionId"
          [entityType]="institutionAffilationType"
        ></phscw-entity-affiliation>
      }
      @if (activeSubmodule == 'discounts') {
        <phscw-institutions-discounts></phscw-institutions-discounts>
      }
      @if (activeSubmodule == 'documents') {
        <phscw-institutions-documents></phscw-institutions-documents>
      }
      @if (activeSubmodule == 'orders') {
        <phscw-institutions-orders></phscw-institutions-orders>
      }
      @if (activeSubmodule == 'orders2') {
        <phscw-institutions-orders2></phscw-institutions-orders2>
      }
      @if (activeSubmodule == 'invoices') {
        <phscw-institutions-invoices></phscw-institutions-invoices>
      }
      @if (activeSubmodule == 'sales') {
        <phscw-institutions-sales></phscw-institutions-sales>
      }
      @if (activeSubmodule == 'tourneemaster') {
        <phscw-institutions-tourneemaster
        ></phscw-institutions-tourneemaster>
      }
      @if (activeSubmodule == 'edetailer') {
        <phscw-institutions-edetailer></phscw-institutions-edetailer>
      }
      @if (activeSubmodule == 'product-analysis') {
        <phscw-institutions-product-analysis
        ></phscw-institutions-product-analysis>
      }
      @if (activeSubmodule == 'additional-data') {
        <phscw-institutions-additional-data
          [institutionId]="institutionId"
        ></phscw-institutions-additional-data>
      }
      @if (activeSubmodule == 'events') {
        <phscw-institutions-events></phscw-institutions-events>
      }
    }
  </div>
</div>
